module.exports = "<fw-framework-body>\n</fw-framework-body>\n";


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/authenticated-user/authenticated-user.component.html
// module id = 2309
// module chunks = 1